import { Component, OnInit, Input, OnChanges, SimpleChanges, HostListener, Output, EventEmitter, ViewChildren, ElementRef, QueryList, inject } from '@angular/core';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { Router, NavigationEnd, NavigationStart, NavigationCancel, NavigationError  } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter, map } from 'rxjs';

import { NavRoute } from '../nav.route.interface';
import { NavigationService } from '../navigation.service';
import { GlobalService } from './../../services/global.service';

@Component({
    selector: 'pcg-top-secondary-nav'
    , templateUrl: './top-secondary-nav.component.html'
    ,  styleUrls: ['./top-secondary-nav.component.scss']
    ,  standalone: false
})
export class TopSecondaryNavComponent implements OnInit, OnChanges {

    public navService = inject(NavigationService);
    public router = inject(Router);
	private title = inject(Title);

	@Input() navRoutes: NavRoute[] = [];
	@Input() rootNavId!: string;
	@Input() routeNavId!: string;
	@Input() forceSelect!: string;
	@Input() tabPanel: any;

	@Output() clickedNav = new EventEmitter<boolean>();

    @ViewChildren('navLink', { read: ElementRef }) navLinks!: QueryList<ElementRef>; 

	loopNavRoutes: NavRoute[] = [];
    hrefLocation: string = ""

	faArrowLeft = faArrowLeft;

    isMobile!: boolean;

	@HostListener('window:resize') onResize() { this.isMobile = GlobalService.setIsMobile(window.innerWidth); }

	ngOnInit() { 
        this.router.events.pipe(
            filter((e) =>
                e instanceof NavigationStart 
                || e instanceof NavigationEnd 
                || e instanceof NavigationCancel 
                || e instanceof NavigationError
            )
            , map((e) => e instanceof NavigationStart)
        ).subscribe(e => { this.getActiveLink() });
		this.isMobile = GlobalService.setIsMobile(window.innerWidth);
		this.loopNavRoutes = this.getNavRoutes(); 
		// Set a descriptive title for the page instead of the default "Schedule2.IT" title when one is not set.
		if (this.title.getTitle() === "Julio App") { this.title.setTitle(this.mainNavTitle() ?? "Julio App"); }
    }

	ngOnChanges(changes: SimpleChanges) {
		this.getActiveLink();	
		const chng = changes['navRoutes'];
		const cur = chng?.currentValue;
		const prev = chng?.previousValue;
		if (cur !== prev) { 
			this.loopNavRoutes = this.getNavRoutes();
			this.focusNewlySelectedNav(); 
		}
	}

	// Show or hide submenu based on dropdown click
	clickDropdown(childMenu: NavRoute) {
		this.navService.currNav.set(childMenu);
		return false;
	}

    redirect(route: any) { 
		if (route.openNewTab) { this.openInNewTab(route.path); }
		//else { this.router.navigateByUrl(route.path); }
		this.focusNewlySelectedNav(); 
		return true;
	}

    openInNewTab(namedRoute: string) {
		let newRelativeUrl = this.router.createUrlTree([namedRoute]);
		let baseUrl = window.location.href.replace(this.router.url, '');
		window.open(baseUrl + newRelativeUrl, '_blank');
	}

    getActiveLink() {
		// parse URL for active link in subnav
		let urlSegments = window.location.href.split(document.getElementsByTagName('base')[0].href)[1].split('/');
		if (
			!isNaN(Number(urlSegments[urlSegments?.length - 1])) 
			&& !isNaN(Number(urlSegments[urlSegments?.length - 2]))
		) { this.hrefLocation = urlSegments.slice(0, urlSegments?.length - 2).join("/"); } 
		else if (
			!isNaN(Number(urlSegments[urlSegments?.length - 1])) 
			&& isNaN(Number(urlSegments[urlSegments?.length - 2]))
		) { this.hrefLocation = urlSegments.slice(0, urlSegments?.length - 1).join("/"); } 
		else { this.hrefLocation = urlSegments.join("/"); }
	}

	getNavRoutes() {
		const routeIndex = this.navService.getCurrRouteIndex(this.navRoutes);
		return this.navRoutes?.map((o, i) => { return { ...o, index: i }; })
			.filter(route => 
				!route?.shouldDisplay 
				|| route.ellipseAfter 
				|| route.ellipseBefore 
				|| route?.shouldDisplay(routeIndex!)
			) ?? [];
	}

    mainNavTitle() {
		if (this.hrefLocation === this.navService.currNav()?.path) { return this.navService.currNav()?.name; }
		return this.navService.currNav()?.name;
	}
	
    private focusNewlySelectedNav() {
        if (this.isMobile) {
            setTimeout(() => {
                if (
                    this.navLinks 
                    && this.navLinks.length > 0
                ) { 
                    const selectedNav = this.navLinks.find(link => link.nativeElement.classList.contains('link-active'));
                    if (selectedNav) {
                        selectedNav.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        selectedNav.nativeElement.focus();
                    }
                }
            }, 0);
        }
	}
}
